module.exports = __webpack_public_path__ + "img/case-2.1cb7f1de.png";